export default "__VITE_ASSET__X72Vu$NC__"